import { render, staticRenderFns } from "./VideoJs.vue?vue&type=template&id=ed519606"
import script from "./VideoJs.vue?vue&type=script&lang=js"
export * from "./VideoJs.vue?vue&type=script&lang=js"
import style0 from "./VideoJs.vue?vue&type=style&index=0&id=ed519606&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports